module.exports = __webpack_public_path__ + "static/img/m_name.8b3fecc.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/tysdags/m_name.png
// module id = adpl
// module chunks = 7